module.exports = __webpack_public_path__ + "static/media/Sec-4_Banner_New_VN.56a6e842.png";